import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["label", "required", "children", "handleChange", "style", "addNew", "handleAddNew", "addBtnName", "placeholder", "className", "inline", "mode", "error", "meta", "showBorder", "errorInPopover", "warning", "loading", "filterOption", "value", "defaultValue", "options", "containerClassName", "labelClassName", "id", "suffixIcon"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable jsx-a11y/no-static-element-interactions */
/**
 * Created by Yash Sharma on 07/12/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Select as SelectAnt } from 'antd';
import _noop from 'lodash/noop';
import _isNil from 'lodash/isNil';
import _castArray from 'lodash/castArray';
import _filter from 'lodash/filter';
import _isFunction from 'lodash/isFunction';
import _isArray from 'lodash/isArray';
import _keyBy from 'lodash/keyBy';
import _map from 'lodash/map';
import { defaultMemoize } from 'reselect';
import { EMPTY_OBJECT, EMPTY_STRING, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import Label from '../../atoms/Label';
import Button from '../../atoms/Button';
import styles from '../../atoms/Input/input.module.scss';
import PropertControlledComponent from '../PropertyControlledComponent';
import Content from '../../atoms/Content';
import FontIcon, { SIZES } from '../../atoms/FontIcon';
import { Consumer } from '../AntdPopupContainerContext';
import { computeGetPopupContainerProp } from '../../utils/popUpUtils';
import selectStyles from './select.module.scss';
import Ellipsis from '../../atoms/Ellipsis';
var computeSelectExtraProps = function computeSelectExtraProps(_ref) {
  var scrollParentSelector = _ref.scrollParentSelector,
    scrollParentRef = _ref.scrollParentRef;
  return Object.assign({}, computeGetPopupContainerProp({
    scrollParentRef: scrollParentRef,
    scrollParentSelector: scrollParentSelector
  }));
};
var Option = SelectAnt.Option;
var value = 'value';
var configLabel = 'label';
var DEFAULT_ADD_BUTTON_NAME = __('Add New');
var Select = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Select, _React$PureComponent);
  var _super = _createSuper(Select);
  function Select(props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "castArray", defaultMemoize(_castArray));
    _defineProperty(_assertThisInitialized(_this), "keyBy", defaultMemoize(_keyBy));
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      var onFocus = _this.props.onFocus;
      _this.setState({
        hasFocus: true
      });
      onFocus();
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      var onBlur = _this.props.onBlur;
      _this.setState({
        hasFocus: false
      });
      onBlur();
    });
    _defineProperty(_assertThisInitialized(_this), "renderOptions", function () {
      var _this$props = _this.props,
        options = _this$props.options,
        ellipsisLength = _this$props.ellipsisLength;
      var _assertThisInitialize = _assertThisInitialized(_this),
        config = _assertThisInitialize.config;
      return _map(options, function (item) {
        return /*#__PURE__*/React.createElement(Option, {
          key: item[config.value],
          value: item[config.value],
          disabled: item.disabled
        }, ellipsisLength ? /*#__PURE__*/React.createElement(Ellipsis, {
          length: ellipsisLength,
          tooltip: true
        }, item[config.label]) : item[config.label]);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDefaultAction", function (e) {
      e.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "getSuffixIcon", function (suffixIcon, loading) {
      var changeSuffixIconColor = _this.props.changeSuffixIconColor;
      var _this$state = _this.state,
        hasFocus = _this$state.hasFocus,
        isDropDownVisible = _this$state.isDropDownVisible;
      if (loading) return null;
      return suffixIcon || /*#__PURE__*/React.createElement(FontIcon, {
        size: SIZES.S,
        className: cx(_defineProperty({}, selectStyles.iconHasFocus, changeSuffixIconColor && hasFocus), _defineProperty({}, selectStyles.popoverOpen, isDropDownVisible), _defineProperty({}, selectStyles.popoverClose, !isDropDownVisible))
      }, "icon-chevron-down");
    });
    _defineProperty(_assertThisInitialized(_this), "getValue", function () {
      var _this$props2 = _this.props,
        value = _this$props2.value,
        defaultValue = _this$props2.defaultValue,
        options = _this$props2.options,
        config = _this$props2.config,
        getValue = _this$props2.getValue;
      if (_isFunction(getValue)) return getValue();
      var values = _this.castArray(value);
      var validValues = _this.keyBy(options, config.value);
      var verifiedValues = _filter(values, function (val) {
        return !_isNil(validValues[val]);
      });
      if (verifiedValues.length) {
        return _isArray(value) ? verifiedValues : value;
      }
      return defaultValue;
    });
    _defineProperty(_assertThisInitialized(_this), "onDropdownVisibleChange", function (isDropDownVisible) {
      var onDropdownVisibleChange = _this.props.onDropdownVisibleChange;
      onDropdownVisibleChange(isDropDownVisible);
      _this.setState({
        isDropDownVisible: isDropDownVisible
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getRemoveIcon", function () {
      return /*#__PURE__*/React.createElement(FontIcon, {
        size: SIZES.S
      }, "icon-close2");
    });
    var _config = _this.props.config;
    _this.state = {
      hasFocus: false,
      isDropDownVisible: false
    };
    _this.config = {
      label: _config.label,
      value: _config.value
    };
    return _this;
  }
  _createClass(Select, [{
    key: "render",
    value: function render() {
      var _cx4,
        _this2 = this;
      var _this$props3 = this.props,
        label = _this$props3.label,
        required = _this$props3.required,
        children = _this$props3.children,
        handleChange = _this$props3.handleChange,
        style = _this$props3.style,
        addNew = _this$props3.addNew,
        handleAddNew = _this$props3.handleAddNew,
        addBtnName = _this$props3.addBtnName,
        placeholder = _this$props3.placeholder,
        className = _this$props3.className,
        inline = _this$props3.inline,
        mode = _this$props3.mode,
        error = _this$props3.error,
        meta = _this$props3.meta,
        showBorder = _this$props3.showBorder,
        errorInPopover = _this$props3.errorInPopover,
        warning = _this$props3.warning,
        loading = _this$props3.loading,
        filterOption = _this$props3.filterOption,
        value = _this$props3.value,
        defaultValue = _this$props3.defaultValue,
        options = _this$props3.options,
        containerClassName = _this$props3.containerClassName,
        labelClassName = _this$props3.labelClassName,
        id = _this$props3.id,
        suffixIcon = _this$props3.suffixIcon,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      var hasFocus = this.state.hasFocus;
      var errorInComponent = error || meta && meta.touched && meta.error;
      var hasWarning = !error && !!warning;
      var selectWrapClass = cx('relative', {
        'd-inline-block': inline
      }, containerClassName);
      var selectClass = cx(className, selectStyles.select, showBorder && selectStyles.selectBoxBorder, (_cx4 = {}, _defineProperty(_cx4, selectStyles.selectError, errorInComponent), _defineProperty(_cx4, selectStyles.selectWarning, hasWarning), _defineProperty(_cx4, selectStyles.hasFocus, hasFocus), _cx4));
      return /*#__PURE__*/React.createElement(Consumer, null, function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT,
          scrollParentRef = _ref2.scrollParentRef,
          scrollParentSelector = _ref2.scrollParentSelector;
        var extraProps = computeSelectExtraProps({
          scrollParentSelector: scrollParentSelector,
          scrollParentRef: scrollParentRef
        });
        return /*#__PURE__*/React.createElement("div", {
          className: selectWrapClass
        }, label && /*#__PURE__*/React.createElement(Label, {
          required: required,
          className: cx(styles.label, labelClassName)
        }, label), /*#__PURE__*/React.createElement(SelectAnt, _extends({
          onChange: handleChange,
          style: style,
          placeholder: placeholder,
          suffixIcon: _this2.getSuffixIcon(suffixIcon, loading),
          dropdownRender: function dropdownRender(menu) {
            return /*#__PURE__*/React.createElement("div", {
              onMouseDown: _this2.handleDefaultAction,
              id: "".concat(id, "SearchList")
            }, menu, ' ', addNew && /*#__PURE__*/React.createElement(Button, {
              className: selectStyles.addNewButton,
              onClick: handleAddNew,
              view: Button.VIEW.TERTIARY,
              id: "createNew"
            }, addBtnName));
          },
          loading: loading,
          mode: mode
        }, rest, extraProps, {
          className: selectClass,
          onFocus: _this2.handleFocus,
          onBlur: _this2.handleBlur,
          filterOption: filterOption,
          defaultValue: defaultValue,
          options: options,
          value: _this2.getValue(),
          id: id,
          onDropdownVisibleChange: _this2.onDropdownVisibleChange,
          removeIcon: _this2.getRemoveIcon()
        }), children || _this2.renderOptions()), /*#__PURE__*/React.createElement(PropertControlledComponent, {
          controllerProperty: errorInComponent && !errorInPopover
        }, /*#__PURE__*/React.createElement(Content, {
          className: selectStyles.errorComponent
        }, " ", errorInComponent, " ")), /*#__PURE__*/React.createElement(PropertControlledComponent, {
          controllerProperty: hasWarning
        }, /*#__PURE__*/React.createElement(Content, {
          className: selectStyles.warningComponent
        }, " ", warning, " ")));
      });
    }
  }]);
  return Select;
}(React.PureComponent);
_defineProperty(Select, "propTypes", {
  options: PropTypes.array,
  onDropdownVisibleChange: PropTypes.func,
  handleChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  children: PropTypes.node,
  config: PropTypes.object,
  style: PropTypes.object,
  addNew: PropTypes.bool,
  handleAddNew: PropTypes.func,
  addBtnName: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  inline: PropTypes.bool,
  className: PropTypes.string,
  mode: PropTypes.any,
  error: PropTypes.string,
  warning: PropTypes.string,
  id: PropTypes.string,
  meta: PropTypes.object,
  showBorder: PropTypes.bool,
  errorInPopover: PropTypes.bool,
  loading: PropTypes.bool,
  suffixIcon: PropTypes.node,
  containerClassName: PropTypes.string,
  filterOption: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  ellipsisLength: PropTypes.number,
  changeSuffixIconColor: PropTypes.bool,
  labelClassName: PropTypes.string
});
_defineProperty(Select, "defaultProps", {
  options: EMPTY_ARRAY,
  onDropdownVisibleChange: _noop,
  handleChange: _noop,
  onFocus: _noop,
  onBlur: _noop,
  disabled: false,
  required: false,
  children: EMPTY_STRING,
  config: {
    value: value,
    label: configLabel
  },
  style: EMPTY_OBJECT,
  addNew: false,
  handleAddNew: _noop,
  addBtnName: DEFAULT_ADD_BUTTON_NAME,
  placeholder: __('Select'),
  label: EMPTY_STRING,
  labelClassName: EMPTY_STRING,
  inline: false,
  className: EMPTY_STRING,
  mode: EMPTY_STRING,
  error: EMPTY_STRING,
  meta: EMPTY_OBJECT,
  warning: EMPTY_STRING,
  showBorder: true,
  loading: false,
  errorInPopover: false,
  suffixIcon: null,
  filterOption: false,
  containerClassName: null,
  id: '',
  ellipsisLength: 0,
  changeSuffixIconColor: false
});
_defineProperty(Select, "Option", Option);
export default Select;